export const clamp = (value, min, max) => {
    if (min > max)
        [min, max] = [max, min];
    return Math.max(min, Math.min(value, max));
};
export const parseRatio = (ratioString) => {
    const match = ratioString.match(/^(\d+)[/:-](\d+)$/);
    if (match && match.length === 3) {
        const width = parseInt(match[1], 10);
        const height = parseInt(match[2], 10);
        return [width, height];
    }
    return null;
};
//# sourceMappingURL=helpers.js.map